import { api } from "src/api/endpoints"

export const getUsersScreens = ({
    page,
    limit,
    email,
    userId,
    pairingCode,
    status,
}) => {
    return async (dispatch) => {
        try {
            const resp = await api.post('/screensManagerAD/list', {
                page,
                limit,
                email,
                userId,
                pairingCode,
                status
            })
            dispatch({
                type: "getScreens",
                payload: resp.data
            })
        } catch (err){}
    }
}